import React from "react";
import Box from "@mui/material/Box";
import VerifiedIcon from "@mui/icons-material/Verified";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import UserAvatar from "../userAvatar.js";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import IconButton from "@mui/material/IconButton";
import {ButtonGroup, BottomNavigation, Paper, Chip} from "@mui/material";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import AddIcon from "@mui/icons-material/Add";
import BarChartIcon from "@mui/icons-material/BarChart";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import CreatableSelect from "react-select/creatable";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Table from "@mui/material/Table";
import {Tabs, Tab} from "@mui/material";
import {Helmet} from "react-helmet";
import TableRow from "@mui/material/TableRow";
import {Button, Grid, TextField, Card, Checkbox} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import {useState} from "react";
import {styled} from "@mui/material/styles";
import {Link, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import "../home/home.css";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import {completeGoogleLogin} from "../../apihelper/login";
import CircularProgress from "@mui/material/CircularProgress";
import SidebarMenuList from "../../includes/sidebarMenuList.jsx";
import PortFolioGallery from "../home/PortFolioGallery.js";
import BestCryptos from "../home/bestcryptos.js";
import {useLocation} from "react-router-dom";
import {useParams} from "react-router-dom";
import {getTotalunit, getFetchdropdown} from "../../apihelper/cryptocurrencylist";
import PromoBanner from "../promoBanner.js";
import Dialog from "@mui/material/Dialog";
import HiddenGems from "./hidden_gems.js";
import BreakOutStars from "./breakout_stars.js";
import SmartMoneyPicks from "./smart_money_picks.js";
import CustomPortfolio from "../customPortfolio.js";
import CryptoReplacement from "../crypto_Replacement.js";
import PortfolioComparator from "../portfolioComparator.js";
import {tabLink} from "../../common/constant/tablink.jsx";
import BottomTab from "../../common/hooks/BottomTab.jsx";
import LoginPopUp from "../../common/alert/login/LoginPopUp.jsx";
const drawerWidth = 292;
//
export default function Home(props) {
    const showPopup = props.showPopup;

    // Check if referral ID exists in URL
    const urlParams = new URLSearchParams(window.location.search);
    let referrerId = urlParams.get("ref");

    // If referral ID is not in the URL, check localStorage
    if (!referrerId) {
        referrerId = localStorage.getItem("referrerId");
    }

    const [selectedmenu, setselectedmenu] = useState("");
    const [options, setOptions] = useState([]);
    const [totalUnits, setTotalUnits] = useState(0);
    const [Usablewallet, setUsablewallet] = useState("");
    const [selectedOption, setSelectedOption] = useState([]);
    const [user_role, setuser_role] = useState("");
    const location = useLocation();
    const queryString = location.search;
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const {window1} = props;
    const [alignment, setAlignment] = React.useState("left");
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [showloginpage, setShowloginpage] = useState(false);
    const loc = location.pathname;
    const [filter, setFilter] = useState("");
    const [loadingForLogin, setLoadingForLogin] = useState(false);
    const [loaderForSymbolLink, setLoaderForSymbolLink] = useState(false);
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const mediaQueryVar5 = useMediaQuery(
        json2mq({
            minWidth: 1900,
        })
    );
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const [path, setPath] = useState("/");

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: "4px 13px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "16px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {[tabLink["ai_portfolios"], tabLink["crypto_replacement"], tabLink["compare_portfolio"]].map(
                            (tab, index) => (
                                <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "150px"}}>
                                    <div style={topTabStyle(isActive(tab.href))}>
                                        <img
                                            src={window?.constants?.asset_path + tab.icon}
                                            alt="icon"
                                            style={{
                                                marginRight: "6px",
                                                height: tab.icon_width || "25px",
                                                filter: iconFilter(isActive(tab.href)),
                                            }}
                                        />
                                        {!mediaQueryVar ? tab.mobile_name : tab.name}
                                    </div>
                                </Link>
                            )
                        )}
                    </div>

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>

                {/* Bottom Tabs */}
                <BottomTab
                    tabs={[
                        tabLink["subscription"],
                        userData ? tabLink["my_portfolio"] : tabLink["presale"],
                        tabLink["profile"],
                    ]}
                    handleLoginClick={handleLoginClick}
                />
            </div>
        );
    };
    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "3px 5px" : "1px 4px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "12px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "13px",
                            minWidth: "200px",
                            textAlign: "center",
                            marginRight: "10px",
                        }}
                    >
                        {[tabLink["ai_portfolios"], tabLink["compare_portfolio"]].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "6px",
                                            height: tab.icon_width || "25px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                               {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>
                        <UserAvatar />

                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "25px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["presale"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>
            </div>
        );
    };

    const drawer = (
        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
            <SidebarMenuList />
        </div>
    );

    useEffect(() => {
        setShowloginpage(true);
        const search = window.location.search;
        const params = new URLSearchParams(search);

        if (params) {
            const googleLoginCode = params.get("code");
            if (googleLoginCode) {
                setLoadingForLogin(true);
                completeGoogleLogin(googleLoginCode).then((data) => {
                    if (data.code == "200") {
                        localStorage.setItem("cw_portfolio_user", JSON.stringify(data.data));
                        const portfolio_userId = localStorage.getItem("portfolio_userId");

                        if (portfolio_userId) {
                            window.location.replace(`${process.env.REACT_APP_HOME_URL}portfolio/${portfolio_userId}`);
                            localStorage.removeItem("portfolio_userId");
                        } else {
                            if (data.data.portfolio_form_redirect === "yes") {
                                window.location.replace(`${process.env.REACT_APP_HOME_URL}profile`);
                            } else {
                                window.location.replace(`${process.env.REACT_APP_HOME_URL}home`);
                            }
                        }
                    } else {
                        console.error("GOOGLE LOGIN FAILED");
                    }
                });
            } else {
                setShowloginpage(false);
            }
        }
    });

    var rows = [],
        i = 0,
        len = 15;
    while (++i <= len) rows.push(i);

    const container = window1 !== undefined ? () => window1().document.body : undefined;

    const [isLoginModalOpen, setLoginModalOpen] = useState(false);

    useEffect(() => {
        if (showPopup) {
            setLoginModalOpen(true); // Open the login modal
            localStorage.setItem("isPopupManuallyOpened", "true");
        }
    }, [showPopup]);

    const handleLoginClick = () => {
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        setLoginModalOpen(true);
    };

    const handleModalClose = () => {
        setLoginModalOpen(false);
        navigate("/custom-portfolio", {replace: true});
    };

    const currentTab = location.pathname.split("/").pop() || "custom-portfolio";
    const [selectedButton, setSelectedButton] = useState(currentTab);

    const tabLabels = {
        "custom-portfolio": "AI Crypto Portfolios",
        "crypto-replacement": "Find Replacement",
        "portfolio-comparison": "Benchmark Crypto Portfolio",
    };
    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, [selectedButton]);

    useEffect(() => {
        setSelectedButton(currentTab); // Sync state when URL changes
    }, [currentTab]);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        navigate(`/${buttonName}`);
    };

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        if (queryString.startsWith("?login") && !userData) {
            setTimeout(() => {
                handleLoginClick();
            }, 6000);
        }
    }, [queryString]);
    const [cryptoData, setCryptoData] = useState([]);

    const [unreadAlerts, setUnreadAlerts] = useState(0);
    useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlertsCount = async () => {
            try {
                const formData = new URLSearchParams();
                formData.append("user_id", userId); // convert to form-encoded format

                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                    },
                    body: formData, // ✅ correct format for this content type
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                setUnreadAlerts(data.unread_notifications);
            } catch (error) {
                console.error("Failed to fetch alerts:", error);
            }
        };

        fetchAlertsCount();
    }, []);

    return (
        <>
            {mediaQueryVar === true ? (
                <Box
                    sx={{
                        flexDirection: mediaQueryVar === false ? "column" : "",
                        display: "flex",
                        height: "100vh",
                    }}
                    className="maindiv"
                >
                    <Helmet>
                        <title>{tabLabels[currentTab]}</title>
                    </Helmet>
                    <CssBaseline />
                    <div className="windowheader">
                        <AppBar
                            position="fixed"
                            sx={{
                                width: {sm: `calc(100% - ${drawerWidth}px)`},
                                ml: {sm: `${drawerWidth}px`},
                            }}
                            style={{
                                backgroundColor: "white",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Toolbar>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="start"
                                    onClick={handleDrawerToggle}
                                    sx={{mr: 2, display: {sm: "none"}}}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <img
                                    src="images/logo_with_bg.png"
                                    width={100}
                                    height={20}
                                    alt="CWLOGO"
                                    style={{margin: "10px", borderRadius: "5px"}}
                                />
                            </Toolbar>
                        </AppBar>
                    </div>

                    <Box
                        component="nav"
                        sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
                        aria-label="mailbox folders"
                    >
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            ModalProps={{
                                keepMounted: true,
                            }}
                            sx={{
                                display: {xs: "block", sm: "none"},
                                "& .MuiDrawer-paper": {
                                    boxSizing: "border-box",
                                    width: drawerWidth,
                                    backgroundColor: "white",
                                    color: "#727376",
                                },
                            }}
                        >
                            {drawer}
                        </Drawer>
                        <Drawer
                            variant="permanent"
                            sx={{
                                display: {xs: "none", sm: "block"},

                                "& .MuiDrawer-paper": {
                                    boxSizing: "border-box",
                                    width: drawerWidth,
                                    backgroundColor: "white",
                                    color: "#727376",
                                },
                            }}
                            open
                        >
                            {drawer}
                        </Drawer>
                    </Box>

                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            p: 3,
                            width: {sm: `calc(100% - ${drawerWidth}px)`},
                            backgroundColor: "#EDF1F6",
                            padding: "2vw",
                            flexDirection: "column",
                            minHeight: "100vh",
                        }}
                        className="maindiv"
                    >
                        {isLoginModalOpen && (
                            <LoginPopUp
                                isLoginModalOpen={isLoginModalOpen}
                                setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                                onClose={handleModalClose}
                            />
                        )}

                        {loadingForLogin && (
                            <div
                                style={{
                                    display: "flex",
                                    alignContent: "center",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: "30px",
                                }}
                            >
                                <CircularProgress />
                            </div>
                        )}
                        {!loadingForLogin && (
                            <>
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                    {/* <Box
                                        sx={{
                                            backgroundColor: "#1877F2",
                                            paddingTop: {xs: "10px", sm: "4px"},
                                            paddingLeft: {xs: "0px", sm: "0px"},
                                            paddingRight: {xs: "0px", sm: "0px"},
                                            paddingBottom: {xs: "0px", sm: "4px"},
                                            borderRadius: "50px",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            width: "498px",
                                            height: {xs: "44px", sm: "48px"},
                                            border: "none",
                                            marginLeft: "17px",
                                            marginTop: "-10px",
                                        }}
                                    > */}
                                    {/* <Tabs
                                            value={selectedButton}
                                            onChange={(event, newValue) => handleButtonClick(newValue)}
                                            aria-label="basic tabs example"
                                            sx={{
                                                alignSelf: mediaQueryVar === true ? "flex-start" : "",
                                                marginLeft: mediaQueryVar === true ? "2px" : "2px",
                                                borderRadius: "50px",
                                                border: "none",
                                                "& .MuiTabs-indicator": {
                                                    display: "none",
                                                },
                                                display: "flex",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <Tab
                                                label="AI Portfolios"
                                                value="custom-portfolio"
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    bottom: "0px",
                                                    marginTop: "1.1px",
                                                    marginBottom: "0px",
                                                    marginLeft: "3px",
                                                    marginRight: "3px",
                                                    paddingBottom: "2px",
                                                    paddingTop: "0px",
                                                    paddingLeft: "20px",
                                                    paddingRight: "20px",
                                                    minHeight: "20px",
                                                    lineHeight: {xs: "28px", sm: "36px"},
                                                    borderRadius:
                                                        selectedButton === "custom-portfolio" ? "20px" : "20px", // Rounded corners for selected tab
                                                    textTransform: "none",
                                                    fontSize: {xs: "13px", sm: "16px"},
                                                    fontStyle: "normal",
                                                    fontWeight: selectedButton === "custom-portfolio" ? "700" : "500",

                                                    backgroundColor:
                                                        selectedButton === "custom-portfolio"
                                                            ? "#FFFFFF"
                                                            : "transparent", // White background for selected tab
                                                    color:
                                                        selectedButton === "custom-portfolio"
                                                            ? "#000000 !important"
                                                            : "#FFFFFF", // Black text for selected tab
                                                    border: "none", // Remove border for tabs
                                                    background:
                                                        selectedButton === "custom-portfolio"
                                                            ? "#FFFFFF"
                                                            : "transparent", // Blue background for unselected tab
                                                }}
                                            />

                                            <Tab
                                                label="Replace Crypto"
                                                value="crypto-replacement"
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    bottom: "0px",
                                                    marginTop: "0px",
                                                    marginBottom: "0px",
                                                    marginLeft: "3px",
                                                    marginRight: "3px",
                                                    paddingBottom: "0px",
                                                    paddingTop: "0px",
                                                    paddingLeft: "20px",
                                                    paddingRight: "20px",
                                                    minHeight: "20px",
                                                    lineHeight: {xs: "36px", sm: "36px"},
                                                    borderRadius:
                                                        selectedButton === "crypto-replacement" ? "50px" : "50px", // Rounded corners for selected tab
                                                    textTransform: "none",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: selectedButton === "crypto-replacement" ? "700" : "500",

                                                    backgroundColor:
                                                        selectedButton === "crypto-replacement"
                                                            ? "#FFFFFF"
                                                            : "transparent", // White background for selected tab
                                                    color:
                                                        selectedButton === "crypto-replacement"
                                                            ? "#000000 !important"
                                                            : "#FFFFFF", // Black text for selected tab
                                                    border: "none",
                                                    background:
                                                        selectedButton === "crypto-replacement"
                                                            ? "#FFFFFF"
                                                            : "transparent", // Blue background for unselected tab
                                                }}
                                            />
                                            <Tab
                                                label="Compare Portfolio"
                                                value="portfolio-comparison"
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    bottom: "0px",
                                                    marginTop: "0px",
                                                    marginBottom: "0px",
                                                    marginLeft: "3px",
                                                    marginRight: "3px",
                                                    paddingBottom: "0px",
                                                    paddingTop: "0px",
                                                    paddingLeft: "20px",
                                                    paddingRight: "20px",
                                                    minHeight: "20px",
                                                    lineHeight: {xs: "36px", sm: "36px"},
                                                    borderRadius:
                                                        selectedButton === "portfolio-comparison" ? "50px" : "50px", // Rounded corners for selected tab
                                                    textTransform: "none",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight:
                                                        selectedButton === "portfolio-comparison" ? "700" : "500",

                                                    backgroundColor:
                                                        selectedButton === "portfolio-comparison"
                                                            ? "#FFFFFF"
                                                            : "transparent", // White background for selected tab
                                                    color:
                                                        selectedButton === "portfolio-comparison"
                                                            ? "#000000 !important"
                                                            : "#FFFFFF", // Black text for selected tab
                                                    border: "none", // Remove border for tabs
                                                    background:
                                                        selectedButton === "portfolio-comparison"
                                                            ? "#FFFFFF"
                                                            : "transparent", // Blue background for unselected tab
                                                }}
                                            />
                                        </Tabs> */}
                                    {/* </Box> */}
                                    <div style={{display: "flex"}}>
                                        {/* <div
                                            className="notification-section position-relative"
                                            onClick={() => navigate("/alerts")}
                                        >
                                            <NotificationIcon className="notification-icon fa-2x" />
                                            <span className="badge rounded-pill badge-notification bg-danger position-absolute top-0 start-100 ">
                                                {unreadAlerts}
                                            </span>
                                        </div> */}

                                        <div
                                            style={{
                                                position: "fixed",
                                                top: 0,
                                                left: drawerWidth,
                                                width: `calc(100% - ${drawerWidth}px)`,
                                                backgroundColor: "#ffffff",
                                                zIndex: 1000,
                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                height: "100px", // You may need to increase this if banner + nav exceeds 100px
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <PromoBanner />
                                            <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        marginBottom: "20px",
                                        flexDirection: "column",
                                        marginTop: "200px",
                                    }}
                                >
                                    {selectedButton === "custom-portfolio" ? (
                                        <CustomPortfolio filter={filter} onButtonClick={handleButtonClick} />
                                    ) : selectedButton === "crypto-replacement" ? (
                                        <CryptoReplacement filter={filter} onButtonClick={handleButtonClick} />
                                    ) : selectedButton === "portfolio-comparison" ? (
                                        <PortfolioComparator filter={filter} onButtonClick={handleButtonClick} />
                                    ) : null}
                                </div>
                            </>
                        )}
                    </Box>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "100vh", // Ensures it takes at least the full viewport height
                        flexGrow: 1, // Allows the Box to grow and fill the available space
                        overflowY: "auto",
                    }}
                >
                    <Helmet>
                        <title>{tabLabels[currentTab]}</title>
                    </Helmet>
                    <CssBaseline />

                    <Box
                        component="nav"
                        sx={{
                            width: "100%", // Take full width on mobile
                        }}
                        aria-label="mailbox folders"
                    >
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            ModalProps={{
                                keepMounted: true,
                            }}
                            sx={{
                                "& .MuiDrawer-paper": {
                                    width: drawerWidth, // Adjust width for mobile
                                    backgroundColor: "white",
                                    color: "#727376",
                                },
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Box>

                    <div style={{backgroundColor: "white", position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000}}>
                        <Box
                            component="main"
                            sx={{
                                height: "100vh",
                                flexGrow: 1,
                                paddingTop: 3,
                                paddingBottom: 1,
                                paddingLeft: 1,
                                paddingRight: 0,
                                backgroundColor: "white",
                                paddingBottom: "2vw",
                                marginRight: "6px",
                                overflow: "auto",
                            }}
                            className="maindiv"
                        >
                            {isLoginModalOpen && (
                                <LoginPopUp
                                    isLoginModalOpen={isLoginModalOpen}
                                    setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                                    onClose={handleModalClose}
                                />
                            )}

                            {loadingForLogin && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginTop: "30px",
                                    }}
                                >
                                    <CircularProgress />
                                </div>
                            )}

                            {!loadingForLogin && (
                                <>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Typography
                                            variant="h6"
                                            component="div"
                                            style={{
                                                fontFamily: "Satoshi, sans-serif",
                                                fontWeight: 500,
                                                fontSize: "20px",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    backgroundColor: "#1877f2",
                                                    padding: "4px 4px",
                                                    borderRadius: "5px",
                                                    color: "white",
                                                }}
                                            >
                                                {selectedButton === "custom-portfolio"
                                                    ? "Custom Portfolio"
                                                    : selectedButton === "crypto-replacement"
                                                    ? "Crypto Replacement"
                                                    : selectedButton === "portfolio-comparison"
                                                    ? "Portfolio Comparison"
                                                    : ""}
                                            </span>
                                        </Typography>

                                        {/* <div style={{display: "flex"}}>
                                            <div
                                                className="notification-section position-relative"
                                                onClick={() => navigate("/alerts")}
                                            >
                                                <NotificationIcon className="notification-icon fa-2x" />
                                                <span className="badge rounded-pill badge-notification bg-danger position-absolute top-0 start-100 ">
                                                    {unreadAlerts}
                                                </span>
                                            </div>
                                            <IconButton
                                                color="inherit"
                                                aria-label="open drawer"
                                                edge="end"
                                                onClick={handleDrawerToggle}
                                                sx={{display: {sm: "none"}, ml: "auto"}} // ml: 'auto' can be removed since flex does the job
                                            >
                                                <img
                                                    src={window.constants.asset_path + "/images/menubar.svg"}
                                                    alt="Menu Icon"
                                                    style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        marginRight: "17px",
                                                        marginBottom: "10px",
                                                        marginTop: "0px",
                                                    }}
                                                />
                                            </IconButton>
                                        </div> */}

                                        <div
                                            style={{
                                                position: "fixed",
                                                top: 0,
                                                left: 0, // aligns it to the right of the sidebar
                                                width: "100%", // takes full width minus sidebar
                                                backgroundColor: "#ffffff",
                                                zIndex: 1000,
                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                height: "100px",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <PromoBanner />
                                            <TopNavigationMobile unreadAlerts={unreadAlerts} />
                                        </div>
                                    </div>

                                    {/* <Grid
                                        container
                                        justifyContent="flex-end"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            width: "100%",
                                            marginBottom: "0px",
                                            marginTop: "10px",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                backgroundColor: "#1877F2", // Background color for the container
                                                paddingTop: "3.105px", // Padding inside the container
                                                paddingLeft: "0px",
                                                paddingRight: "0px",
                                                paddingBottom: "3.105px",
                                                borderRadius: "38.042px", // Border radius for the container
                                                display: "inline-flex", // Make sure the box is flexible
                                                justifyContent: "center", // Center the content
                                                alignItems: "center", // Center the content
                                                width: "340px", // Full width on extra small screens
                                                height: "39px",
                                                border: "none",
                                                marginLeft: "0px",
                                            }}
                                        >
                                            <Tabs
                                                value={selectedButton}
                                                onChange={(event, newValue) => handleButtonClick(newValue)}
                                                aria-label="basic tabs example"
                                                sx={{
                                                    marginLeft: "0px",
                                                    "& .MuiTabs-indicator": {
                                                        display: "none",
                                                    },
                                                    display: "flex", // Make sure the tabs are displayed in a row
                                                    overflow: "hidden", // Prevent the tabs from spilling out of the border radius
                                                }}
                                            >
                                                <Tab
                                                    label="AI Portfolios"
                                                    value="custom-portfolio"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        borderRadius: "20.962px",
                                                        minHeight: "31.5px",
                                                        height: "31.5px",
                                                        fontWeight:
                                                            selectedButton === "custom-portfolio" ? "700" : "500",
                                                        marginLeft: "1px",
                                                        paddingLeft: "-15px",
                                                        marginTop: "8px",
                                                        border: "1px solid black",
                                                        marginBottom: "-5px",
                                                        fontSize: "11px",
                                                        marginRight: "-15px",
                                                        backgroundColor:
                                                            selectedButton === "custom-portfolio"
                                                                ? "#FFFFFF"
                                                                : "transparent", // White background for selected tab
                                                        color:
                                                            selectedButton === "custom-portfolio"
                                                                ? "#000000 !important"
                                                                : "#FFFFFF", // Black text for selected tab
                                                        textTransform: "none",
                                                        border: "none",
                                                    }}
                                                />
                                                <Tab
                                                    label="Replace Crypto"
                                                    value="crypto-replacement"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        borderRadius: "20.962px",
                                                        minHeight: "31px",
                                                        height: "31px",
                                                        marginLeft: "10px",
                                                        marginTop: "8px",
                                                        border: "1px solid black",
                                                        fontWeight:
                                                            selectedButton === "crypto-replacement" ? "700" : "500",
                                                        marginRight: "-13px",
                                                        fontSize: "11px",
                                                        paddingRight: "-8px",
                                                        textTransform: "none",
                                                        backgroundColor:
                                                            selectedButton === "crypto-replacement"
                                                                ? "#FFFFFF"
                                                                : "transparent", // White background for selected tab
                                                        color:
                                                            selectedButton === "crypto-replacement"
                                                                ? "#000000 !important"
                                                                : "#FFFFFF", // Black text for selected tab
                                                        border: "none", // Remove border for tabs
                                                    }}
                                                />
                                                <Tab
                                                    label="Compare Portfolio"
                                                    value="portfolio-comparison"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        borderRadius: "20.962px",
                                                        minHeight: "31px",
                                                        height: "31px",
                                                        marginLeft: "5px",
                                                        marginTop: "8px",
                                                        border: "1px solid black",
                                                        fontWeight:
                                                            selectedButton === "portfolio-comparison" ? "700" : "500",
                                                        marginRight: "0px",
                                                        fontSize: "11px",
                                                        paddingRight: "-8px",
                                                        textTransform: "none",
                                                        backgroundColor:
                                                            selectedButton === "portfolio-comparison"
                                                                ? "#FFFFFF"
                                                                : "transparent", // White background for selected tab
                                                        color:
                                                            selectedButton === "portfolio-comparison"
                                                                ? "#000000 !important"
                                                                : "#FFFFFF", // Black text for selected tab
                                                        border: "none", // Remove border for tabs
                                                    }}
                                                />
                                            </Tabs>
                                        </Box>
                                    </Grid> */}
                                    <div style={{marginTop: "100px"}}>
                                        {selectedButton === "custom-portfolio" ? (
                                            <CustomPortfolio filter={filter} onButtonClick={handleButtonClick} />
                                        ) : selectedButton === "crypto-replacement" ? (
                                            <CryptoReplacement filter={filter} onButtonClick={handleButtonClick} />
                                        ) : selectedButton === "portfolio-comparison" ? (
                                            <PortfolioComparator filter={filter} onButtonClick={handleButtonClick} />
                                        ) : null}
                                    </div>
                                </>
                            )}
                        </Box>
                    </div>

                    {mediaQueryVar === false && (
                        <div
                            style={{
                                position: "fixed",
                                bottom: "0",
                                backgroundColor: "white",
                                width: "105%",
                                zIndex: "1000",
                                boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)", // Optional shadow for depth
                                marginLeft: "-10px",
                            }}
                        >
                            <BottomNavigation showLabels>
                                <BottomNavigationAction
                                    label={<span style={{fontSize: "11px"}}>Best Portfolios</span>}
                                    onClick={() => {
                                        navigate("/portfolio-gallery");
                                    }}
                                    icon={
                                        <img
                                            src={
                                                loc === "/portfolio-gallery"
                                                    ? `${window.constants.asset_path}/images/dashboardS.svg`
                                                    : `${window.constants.asset_path}/images/dashboardU.svg`
                                            }
                                            width={20}
                                            height={20}
                                            alt="Icon"
                                        />
                                    }
                                />
                                <BottomNavigationAction
                                    label={<span style={{fontSize: "11px"}}>Screener</span>}
                                    onClick={() => navigate("/crypto-screener")}
                                    icon={
                                        <img
                                            src={
                                                loc === "/crypto-screener"
                                                    ? `${window.constants.asset_path}/images/portfolioS.svg`
                                                    : `${window.constants.asset_path}/images/portfolioU.svg`
                                            }
                                            width={20}
                                            height={20}
                                            alt="Icon"
                                        />
                                    }
                                />
                                <BottomNavigationAction
                                    label={<span style={{fontSize: "11px"}}>Indices</span>}
                                    onClick={() => navigate("/indices")}
                                    icon={
                                        <img
                                            src={
                                                userData
                                                    ? loc === "/indices"
                                                        ? "/images/dollarS.svg"
                                                        : "/images/dollarU.svg"
                                                    : "/images/right-arrow.png"
                                            }
                                            width={24}
                                            height={24}
                                            alt="Icon"
                                            style={{marginBottom: "-3px"}}
                                        />
                                    }
                                />
                            </BottomNavigation>
                        </div>
                    )}
                </Box>
            )}
        </>
    );
}
